<template>
  <div>
    <v-dialog v-model="dialog" fullscreen persistent>
      <v-card>
        <!-- HEADER -->
        <v-toolbar color="primary" dark>
          <v-btn icon @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <v-toolbar-title>
            Users – {{ orgDetails?.organization_name || "-" }}
          </v-toolbar-title>

          <v-spacer />
        </v-toolbar>

        <!-- CONTENT -->
        <v-card-text class="pa-4">
          <!-- ORG USAGE SUMMARY -->
          <v-row class="mb-4">
            <v-col cols="12" md="3">
              <v-card outlined>
                <v-card-title class="text-subtitle-2">
                  License Type
                </v-card-title>
                <v-card-text class="text-h6">
                  {{
                    orgDetails?.license_type == "HYBRID"
                      ? "BOTH"
                      : orgDetails?.license_type || "-"
                  }}
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12" md="3">
              <v-card outlined>
                <v-card-title class="text-subtitle-2">
                  Annual Users Used
                </v-card-title>
                <v-card-text class="text-h6">
                  {{ orgDetails?.annual_license_user_count_usage || 0 }}
                  /
                  {{ orgDetails?.licensed_user_count || 0 }}
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12" md="3">
              <v-card outlined>
                <v-card-title class="text-subtitle-2">
                  MRR Licenses Used
                </v-card-title>
                <v-card-text class="text-h6">
                  {{ orgDetails?.mrr_license_total_usage || 0 }}
                  /
                  {{ orgDetails?.mrr_license_count || 0 }}
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12" md="3">
              <v-card outlined>
                <v-card-title class="text-subtitle-2">
                  Days Remaining
                </v-card-title>
                <v-card-text class="text-h6">
                  {{ orgDetails?.days_remaining || "-" }}
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <!-- USERS TABLE -->
          <v-data-table :headers="headers" :items="users" :loading="loading" density="compact" class="elevation-0">
            <template v-slot:[`item.user_status`]="{ item }">
              <v-chip :color="item.user_status === 'ACTIVE' ? 'success' : 'error'" size="small">
                {{ item.user_status }}
              </v-chip>
            </template>
            <template v-slot:[`item.created_on`]="{ item }">
              {{ formatDate(item.created_on) }}
            </template>
            <template v-slot:[`item.user_license_type`]="{ item }">
              {{
                item.user_type == "ADMIN" || item.user_type == "PHARMACIST" || item.user_type == "OWNER"
                  ? formatNA(item.user_license_type)
                  : "-"
              }}
            </template>
            <template v-slot:[`item.user_type`]="{ item }">
              {{ fetchUsertype(item.user_type) }}
            </template>

            <template #no-data> No users found </template>
             <template v-slot:[`item.is_terms_and_conditions_acknowledged`]="{ item }">
              {{ item.is_terms_and_conditions_acknowledged?'Acknowledged':'Not Acknowledged' }}
            </template>
            <template v-slot:[`item.actions`]="{ item }">

              <!-- Resend Invite -->
              <v-btn
                v-if="
                  item.user_cognito_status !== 'CONFIRMED' &&
                  (
                    item.user_cognito_status ||
                    item.user_type === 'OWNER'
                  )
                "
                icon
                variant="text"
                size="small"
                color="warning"
                @click="openResendDialog(item)"
              >
                <v-icon size="18">mdi-email-fast</v-icon>
              </v-btn>

              <!-- Edit License -->
              <v-btn
                v-else-if="
                  orgDetails?.license_type === 'HYBRID' &&
                  (item.user_type === 'ADMIN' || item.user_type === 'PHARMACIST')
                "
                icon
                variant="text"
                size="small"
                color="primary"
                @click="openEditDialog(item)"
              >
                <v-icon size="18">mdi-pencil</v-icon>
              </v-btn>

              <!-- Change Super Admin -->
              <v-btn
                v-else-if="item.user_type === 'OWNER'"
                icon
                variant="text"
                size="small"
                color="primary"
                @click="openChangeOwnerDialog(item)"
              >
                <v-icon size="18">mdi-account-switch</v-icon>
              </v-btn>

              <span v-else>-</span>

            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
    <EditUserLicenseDialog v-model="showEditDialog" :user="selectedUser" @updated="fetchUsers" />
    <ChangeSuperAdminDialog
  v-model="showChangeOwnerDialog"
  :users="users"
  :organization="organization"
  @updated="fetchUsers"
/>
 <ResendInviteDialog
      v-model="showResendDialog"
      :user="selectedUserForResend"
    />
  </div>
</template>

<script>
import ResendInviteDialog from "@/components/Organization/Dailogs/ResendInviteDialog.vue";
import EditUserLicenseDialog from "@/components/Organization/Dailogs/EditUserLicenseDialog.vue";
import ChangeSuperAdminDialog from "@/components/Organization/Dailogs/ChangeSuperAdminDialog.vue";
import { generateClient } from "aws-amplify/api";
import { get_license_usage_summary } from "@/graphql/queries";

const client = generateClient();

export default {
  name: "OrganizationUsersDialog",

  props: {
    modelValue: Boolean,
    organization: Object,
  },
  components: {
    EditUserLicenseDialog,
    ChangeSuperAdminDialog,
    ResendInviteDialog
  },
  emits: ["update:modelValue"],

  data() {
    return {
      loading: false,
      users: [],
      orgDetails: null,
      showChangeOwnerDialog: false,
      ownerUser: null,
      selectedUserForResend: null,
      showResendDialog:false,
      showEditDialog: false,
      selectedUser: null,
      headers: [
        { title: "Name", key: "user_name" },
        { title: "Email", key: "user_email_id" },
        { title: "Role", key: "user_type" },
        { title: "License Type", key: "user_license_type" },
        { title: "Status", key: "user_status" },
         { title: "Acknowledged", key: "is_terms_and_conditions_acknowledged" },
        
        { title: "Created On", key: "created_on" },
        { title: "Actions", key: "actions", sortable: false },
      ],
    };
  },

  computed: {
    dialog: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      },
    },
  },

  watch: {
    dialog(val) {
      if (val) {
        this.fetchUsers();
      } else {
        this.users = [];
        this.orgDetails = null;
        this.$emit("refresh-organizations");
      }
    },
  },

  methods: {
    openChangeOwnerDialog(user) {
  this.ownerUser = user;
  this.showChangeOwnerDialog = true;
},

    openResendDialog(user) {
      this.selectedUserForResend = user;
      this.showResendDialog = true;
    },
    formatNA(value) {
      if (!value || value === "N/A" || value === "n/a") return "-";
      return value;
    },
    openEditDialog(user) {
      this.selectedUser = user;
      this.showEditDialog = true;
    },
    fetchUsertype(value) {
      let data = "-";

      switch (value) {
        case "ADMIN":
          data = "Admin Pharmacist";
          break;
        case "PHARMACIST":
          data = "Pharmacist";
          break;
        case "ADMIN_NO_PHARMACIST":
          data = "Admin Non Pharmacist";
          break;
        case "ACCOUNTANT":
          data = "Accountant";
          break;
        case "OWNER":
          data = "Super Admin";
          break;
        default:
          data = "-";
      }

      return data;
    },
    formatDate(epoch) {
      if (!epoch) return "-";

      const ms = epoch < 1e12 ? epoch * 1000 : epoch; // handle sec/ms
      const date = new Date(ms);

      if (isNaN(date.getTime())) return "-";

      return date.toLocaleDateString("en-US", {
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
      });
    },
    async fetchUsers() {
      this.loading = true;
      try {
        const res = await client.graphql({
          query: get_license_usage_summary,
          variables: {
            input: {
              organization_id: this.organization.organization_id,
            },
          },
        });

        const parsed = JSON.parse(res.data.get_license_usage_summary);

        this.users = parsed.data || [];
        this.orgDetails = parsed.org_details || null;
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
